import React from 'react'
import cx from 'classnames'
import { Link } from 'react-router'
import { compose, lifecycle, withHandlers, withProps } from 'recompose'

import { fetchUserProperties, updateUserPropertiesTheRightWay } from 'app/modules/user/properties/actions'
import {
  properties as userProperties
} from 'app/modules/user/properties/selectors'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { EducationTooltip } from '@driftt/tide-tooltips-legacy'

import './styles.styl'

const CalendarTabHeader = ({ view, closeTooltip, hasSeenCalendarTooltip, hasSeenPersonalizeMeetingEmailsTooltip }) => {
  const meetingsView = view === "MEETINGS"
  const calendarsView = view === "CALENDARS"

  const header = !hasSeenCalendarTooltip
    ? "Manage your calendar settings"
    : "Personalize your meeting emails"

  const body = !hasSeenCalendarTooltip
    ? "Here’s where you can customize when and how people can book meetings with you."
    : "Here’s where you can customize the emails that get sent when someone books a meeting with you."

  const closeTooltipFunc = !hasSeenCalendarTooltip
    ? () => closeTooltip('HAS_SEEN_NEW_CALENDARS_SETTINGS_TAB')
    : () => closeTooltip('HAS_SEEN_PERSONALIZE_MEETING_EMAILS_TOOLTIP')

  return <div>
    <div className="meeting-nav-wrapper">
      <div className="meeting-nav">
        <div className={cx('link', { selected: meetingsView })}>
          <Link to="/settings/calendar">Meeting Types</Link>
        </div>
        <div className={cx('link', { selected: calendarsView })} >
          <EducationTooltip
            className="outreach-enable-tooltip"
            onClose={() => closeTooltipFunc()}
            showTooltip={!hasSeenCalendarTooltip || !hasSeenPersonalizeMeetingEmailsTooltip}
            tooltipSide="right"
            tooltipCaretLocation="middle"
            headerCopy={header}
            bodyCopy={body}
            >
              <Link onClick={() => closeTooltipFunc()} to="/settings/calendar/advanced">Calendar Settings</Link>
          </EducationTooltip>
        </div>
      </div>
    </div>
  </div>
}



const mapStateToProps = (state) => {
  return {
    userProperties: userProperties(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({
      fetchUserProperties,
      updateUserProperties: updateUserPropertiesTheRightWay,
    }, dispatch)
  }
}


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.actions.fetchUserProperties()
    }
  }),
  withProps(props => {
    return {
      hasSeenCalendarTooltip: props.userProperties && props.userProperties.get('HAS_SEEN_NEW_CALENDARS_SETTINGS_TAB', false),
      hasSeenPersonalizeMeetingEmailsTooltip: props.userProperties && props.userProperties.get('HAS_SEEN_PERSONALIZE_MEETING_EMAILS_TOOLTIP', false)
    }
  }),
  withHandlers({
    closeTooltip: props => (property) => props.actions.updateUserProperties({ [property]: true }, false),
  }),
)(CalendarTabHeader)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/CalendarTabHeader/index.js